// This file was auto-generated by Fern from our API Definition.
import { HeaderAuthProvider } from "./auth/HeaderAuthProvider.js";
import * as core from "./core/index.js";
export function normalizeClientOptions(options) {
    return {
        ...options,
        logging: core.logging.createLogger(options?.logging),
    };
}
export function normalizeClientOptionsWithAuth(options) {
    const normalized = normalizeClientOptions(options);
    const normalizedWithNoOpAuthProvider = withNoOpAuthProvider(normalized);
    normalized.authProvider ??= new HeaderAuthProvider(normalizedWithNoOpAuthProvider);
    return normalized;
}
function withNoOpAuthProvider(options) {
    return {
        ...options,
        authProvider: new core.NoOpAuthProvider(),
    };
}
